import React from "react";
import styled from "styled-components";

const FlightTimeDivider = ({ type }) => {
  return (
    <StyledFlightTimeDivider style={{ textAlign: "center" }}>
      <img src={require("../../../assets/images/line.png")} alt="line" />
      <div>{type}</div>
    </StyledFlightTimeDivider>
  );
};

const StyledFlightTimeDivider = styled.div`
  text-align: center;
  > div {
    font-size: 0.75rem;
  }
`;

export default FlightTimeDivider;
